import { ErrorMessage } from '@/app/proxy/proxies';

const FALLBACK_ERROR_KEY = 'doktar_app.common_errors.someting_went_wrong_title';

/**
 * Backend errors arrive as "<code>:<message>". Only the message part is shown to
 * the user; when nothing usable is returned a generic translation key is used.
 */
export function extractBackendErrorMessage(errors?: ErrorMessage[] | { message?: string }[]): string {
  const raw = (errors as { message?: string }[] | undefined)?.[0]?.message;
  if (!raw) {
    return FALLBACK_ERROR_KEY;
  }

  const colonIndex = raw.indexOf(':');
  return colonIndex >= 0 ? raw.slice(colonIndex + 1).trim() : raw;
}
